<template>
  <div class="paginator_layer">
    <div class="paginator_button_wrapper" :style="{ opacity: pages > 1 ? .4 : 0}">
      <v-btn v-for="i in pages" :key="i" icon :class="`btn_page_${i}`" @click="onClick(i)">
        <div class="circle"></div>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    prevPage: -1,
    currentPage: -1,
    pages: 0,
    scale: {
      'screen-max-width': 1070,
      'screen-min-width': 780,
    },
  }),
  mounted() {
    window.addEventListener('resize', this.resize, true)
    this.resize()
  },
  destroyed() {
    window.removeEventListener('resize', this.resize, true)
  },
  methods: {
    onClick(page) {
      if(this.currentPage == page) return

      this.prevPage = this.currentPage
      this.currentPage = page
      this.$emit('change-page', page)

      setTimeout(() => { this.setCurrentPage() })
    },
    resize() {
      let w = window.outerWidth
      
      // 2. set the scale of the page contents
      let scale__ = 1
      if(w >= this.scale['screen-min-width'] && w < this.scale['screen-max-width']) {
        scale__ = (w / this.scale['screen-max-width']).toFixed(2)

      } else if(w < this.scale['screen-min-width']) {
        scale__ = (this.scale['screen-min-width'] / this.scale['screen-max-width']).toFixed(2)
      }
      let el = document.querySelector('.paginator_layer .paginator_button_wrapper')
      if(!el) return

      el.style.transform = `scale(${scale__})`
    },
    setPage(pages, currentPage) {
      if(this.pages != pages) {
        this.pages = pages
      }
      if(this.currentPage != currentPage) {
        this.prevPage = this.currentPage
        this.currentPage = currentPage

        setTimeout(() => { this.setCurrentPage() })
      }
    },
    setCurrentPage() {
      if(this.prevPage != this.currentPage) {
        this.$anime({
          targets: `.paginator_layer .btn_page_${this.prevPage} .circle`,
          backgroundColor: 'rgba(255, 255, 255, 0)',
          duration: 500
        })
      }
      this.$anime({
        targets: `.paginator_layer .btn_page_${this.currentPage} .circle`,
        backgroundColor: 'rgba(255, 255, 255, 1)',
        duration: 500
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.paginator_layer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;

  .paginator_button_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 5rem;

    button[class*=btn_page_] {
      margin: .3rem;

      .circle {
        width: 1.3rem;
        height: 1.3rem;
        border: solid 2px #fff;
        border-radius: 50%;
      }
    }
  }
}
</style>